import React from 'react'

import { useRef, useEffect } from 'react'

import request from '@function/ajax/request'

import FormsStore from '@Store/Forms'

export default function SubmitForm ({ form, id, onError, onSuccess, ...props })
{
	const _submit_ref = useRef();

	const _cbs_refs = useRef();

	useEffect(function ()
	{
		_cbs_refs.current = { onError, onSuccess };
	},
	[onError, onSuccess]);

	useEffect(function ()
	{
		if (!id || _submit_ref.current === id) return;

		FormsStore.update(s => { s[form]._loading = true; });

		_submit_ref.current = id;

		const controller = new AbortController();

		FormsStore.update(function (store)
		{
			const submited_data = { ...store[form] };

			['_submit_id', '_loading']
			.forEach(field => delete submited_data[field]);

			(async function ()
			{
				try
				{
					var response = await request(props.url)
					.config({ controller, keyword: 'action', min_req_time: 300 })
					.post(submited_data);
				}
				catch (update)
				{
					if (controller?.signal?.aborted) return;

					return _cbs_refs.current.onError(update);
				}
				finally
				{
					FormsStore.update(s => { s[form]._loading = false; });
				}

				_cbs_refs.current.onSuccess(response);
			})();
		});

		return () => controller?.abort?.();
	},
	[id, form, props.url]);

	return null;
}